import { DateTime } from 'luxon'
import { buildSearchParam } from '@hooks/useWeekDatesSearchParams'
import { WeekStartsOn } from 'providers/WeekScopeProvider'

interface Options {
  userId: number
  /**
   * The week to open, stated in the linking screen's own terms. Omit to land
   * on the linked user's current week.
   */
  week?: {
    start: DateTime
    /** The convention `start` is expressed in — the linking screen's. */
    startsOn: WeekStartsOn
    /** The convention the time logger will resolve it in — the linked user's. */
    opensAs: WeekStartsOn
  }
}

export const timeLoggerRouteBuilder = ({ userId, week }: Options) => {
  const prefix = `/time-logger/user/${userId}/`

  if (!week) return prefix

  /**
   * The two conventions disagree by a day about which week the boundary days
   * belong to, so translating through `start` itself would land a Monday-start
   * user on the week before. Every convention agrees about the middle of a
   * week, so translate through that instead.
   */
  const midWeek = week.start.plus({ days: 3 })
  const params = buildSearchParam({
    date: midWeek,
    weekStartsOn: week.opensAs,
  })

  return `${prefix}?${params.toString()}`
}
